import { render, staticRenderFns } from "./Statistician.vue?vue&type=template&id=c4c68c78"
import script from "./Statistician.vue?vue&type=script&lang=js"
export * from "./Statistician.vue?vue&type=script&lang=js"
import style0 from "./Statistician.vue?vue&type=style&index=0&id=c4c68c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports